const EmptyState = ({ isLoading, searchQuery, itemName, columnCount = 1 }) => (
  <tr>
    <td colSpan={columnCount || 1} className="px-4 sm:px-6 py-10">
      <div className="flex flex-col items-center justify-center space-y-4">
        <p className="text-gray-500 text-sm">
          {isLoading
            ? "Loading..."
            : searchQuery
            ? `No ${itemName}s found matching "${searchQuery}"`
            : `No ${itemName}s available`}
        </p>
      </div>
    </td>
  </tr>
);

export default EmptyState;
